import isObject from "src/utils/jsHelpers/isObject";

const getSupervisorOptionValue = (supervisorOption) => {
  if (Array.isArray(supervisorOption)) {
    return supervisorOption?.[0]?.value;
  }
  if (isObject(supervisorOption)) {
    return supervisorOption?.value;
  }

  return supervisorOption;
};

export default getSupervisorOptionValue;
